import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { CreateCommanWay, DeleteCommanWay, ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { AxiosResponse } from "axios";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  useDisclosure,
  Input,
  Textarea,
  Card,
  CardHeader,
  CardBody,
  Checkbox,
} from "@heroui/react";
import UseToast from "utils/AfToast";
import Spinner from "utils/Spinner";
import moment from "moment";
import Select from "react-select";
import { Chip } from "@heroui/react";



const NewLead: React.FC = () => {
  const statusOptions = [
  { value: "Under Follow-up", label: "Under Follow-up" },
  { value: "Negotiation", label: "Negotiation" },
  { value: "On Hold", label: "On Hold" },
  { value: "Dropped", label: "Dropped" },
  { value: "Signed", label: "Signed" },
];

  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;

  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  // Form States
  const [title, setTitle] = useState<string>("-");
  const [desc, setDesc] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [company, setCompany] = useState<string>("");
  const [website, setWebsite] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [gst, setGst] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [contactPersonName, setContactPersonName] = useState<string>("");
  const [contactPersonPhone, setContactPersonPhone] = useState<string>("");
  const [contactPersonEmail, setContactPersonEmail] = useState<string>("");
  const [products, setProducts] = useState<any>([]);
  const [source, setSource] = useState<any>(null);
  const [status, setStatus] = useState<any>(statusOptions[0]);
  const [priority, setPriority] = useState<any>({ value: 1, label: "Medium" });
  const [followupDate, setFollowupDate] = useState<string>("");
  const [assignedUser1, setAssignedUser1] = useState<any>(null);
  const [assignedUser2, setAssignedUser2] = useState<any>(null);
  const [assignedUser3, setAssignedUser3] = useState<any>(null);
  const [isPrivate, setIsPrivate] = useState<boolean>(false);
  const [other, setOther] = useState<string>("");

  // Followup States
  const [followupList, setFollowupList] = useState<any>([]);
  const [followupNote, setFollowupNote] = useState<string>("");
  const [followupNextDate, setFollowupNextDate] = useState<string>("");
  const [followupStatus, setFollowupStatus] = useState<any>(null);
  const [editingFollowupId, setEditingFollowupId] = useState<any>(null);

  // User List
  const [userList, setUserList] = useState<any>([]);
  const [productList, setProductList] = useState<any>([]);

  const sourceOptions = [
    { value: "Website", label: "Website" },
    { value: "Referral", label: "Referral" },
    { value: "Cold Call", label: "Cold Call" },
    { value: "Email Campaign", label: "Email Campaign" },
    { value: "Social Media", label: "Social Media" },
    { value: "Trade Show", label: "Trade Show" },
    { value: "Walk-in", label: "Walk-in" },
    { value: "Advertisement", label: "Advertisement" },
    { value: "Other", label: "Other" },
  ];

  const priorityOptions = [
    { value: 0, label: "Low" },
    { value: 1, label: "Medium" },
    { value: 2, label: "High" },
    { value: 3, label: "Urgent" },
  ];

  // Fetch Users
  const { refetch: refetchUsers } = useQuery(
    ["UsersList"],
    () => ListCommanWay("/admin/user/list", { isActive: true }, { paginate: 1000 }),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          let opt = [];
          data.data.data.forEach((p) => {
            opt.push({
              value: p.id,
              label: p.name + " (" + p.username + ")",
            });
          });
          setUserList(opt);
        }
      },
    }
  );

  // Fetch Products
  const { refetch: refetchProducts } = useQuery(["ProductsList"], () => ListCommanWay("/admin/product/list", {}, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = [];
        data.data.data.forEach((p) => {
          opt.push({
            value: p.product_name,
            label: p.product_name,
          });
        });
        setProductList(opt);
      }
    },
  });

  // Fetch Lead Details (Edit Mode)
  const { refetch: refetchLead } = useQuery(["LeadDetail", id], () => ListCommanWay("/admin/lead/list", { id: id }, {}), {
    enabled: isEditMode,
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS" && data.data.data.length > 0) {
        let lead = data.data.data[0];
        if (lead.followupDate == "Invalid Date" || !lead.followupDate) {
          lead.followupDate = "";
        }
        console.log("Lead Data:", lead);
        setTitle(lead.title || "-");
        setDesc(lead.desc || "");
        setName(lead.name || "");
        setEmail(lead.email || "");
        setPhone(lead.phone || "");
        setCompany(lead.company || "");
        setWebsite(lead.website || "");
        setAddress(lead.address || "");
        setGst(lead.gst || "");
        setCity(lead.city || "");
        setContactPersonName(lead.contactPersonName || "");
        setContactPersonPhone(lead.contactPersonPhone || "");
        setContactPersonEmail(lead.contactPersonEmail || "");

        // Set products
        if (lead.products && typeof lead.products === "string") {
          const selectedProducts = lead.products.split(",").map((p) => ({
            value: p,
            label: p,
          }));
          setProducts(selectedProducts);
        }

        setSource(lead.source ? { value: lead.source, label: lead.source } : null);
        setStatus(lead.status ? { value: lead.status, label: lead.status } : null);
        setPriority(lead.priority ? { value: lead.priority, label: lead.priority } : null);
        setFollowupDate(
          lead.followupDate && lead.followupDate !== "Invalid Date"
            ? moment(lead.followupDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD")
            : ""
        );
        setAssignedUser1(lead.assignedUser1 ? { value: lead.assignedUser1, label: lead.assignedUser1 } : null);
        setAssignedUser2(lead.assignedUser2 ? { value: lead.assignedUser2, label: lead.assignedUser2 } : null);
        setAssignedUser3(lead.assignedUser3 ? { value: lead.assignedUser3, label: lead.assignedUser3 } : null);
        setIsPrivate(lead.isPrivate || false);
        setOther(lead.other || "");
      }
    },
  });

  // Fetch Followups
  const { refetch: refetchFollowups, isLoading: isLoadingFollowups } = useQuery(
    ["LeadFollowups", id],
    () => ListCommanWay("/admin/leadfollowups/list", { leadId: Number(id) }, { paginate: 100 }),
    {
      enabled: isEditMode,
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          setFollowupList(data.data.data || []);
        }
      },
    }
  );

  // Create Lead
  const { mutate: mutateCreateLead, isLoading: isCreating } = useMutation(
    (data: any) =>
      CreateCommanWay({
        url: "/admin/lead/create",
        data: data,
      }),
    {
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          UseToast("Lead Created Successfully", "success");
          navigate("/af/leads");
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  // Update Lead
  const { mutate: mutateUpdateLead, isLoading: isUpdating } = useMutation((data: any) => UpdateCommanWay(data), {
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        UseToast("Lead Updated Successfully", "success");
        refetchLead();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  // Add Followup
  const { mutate: mutateAddFollowup, isLoading: isAddingFollowup } = useMutation(
    (data: any) =>
      CreateCommanWay({
        url: "/admin/leadfollowups/create",
        data: data,
      }),
    {
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          UseToast("Followup Added Successfully", "success");
          setFollowupNote("");
          setFollowupNextDate("");
          setFollowupStatus(null);
          setEditingFollowupId(null);
          refetchFollowups();
          onOpenChange();
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  // Update Followup
  const { mutate: mutateUpdateFollowup, isLoading: isUpdatingFollowup } = useMutation((data: any) => UpdateCommanWay(data), {
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        UseToast("Followup Updated Successfully", "success");
        setFollowupNote("");
        setFollowupNextDate("");
        setFollowupStatus(null);
        setEditingFollowupId(null);
        refetchFollowups();
        onOpenChange();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  // Delete Followup
  const { mutate: mutateDeleteFollowup } = useMutation(
    (followupId: any) => DeleteCommanWay({ url: `/admin/leadfollowups/delete/${followupId}`, data: {} }),
    {
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          UseToast("Followup Deleted Successfully", "success");
          refetchFollowups();
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  const handleSubmit = () => {
    if (!company || !contactPersonName || !contactPersonEmail || !contactPersonPhone) {
      UseToast("Please fill all required fields", "error");
      return;
    }

    const leadData = {
      title,
      desc,
      name,
      email,
      phone,
      company,
      website,
      address,
      gst,
      city,
      contactPersonName,
      contactPersonPhone,
      contactPersonEmail,
      products: products.map((p) => p.value).join(", "),
      source: source?.value || null,
      status: status?.value || "Under Follow-up",
      priority: priority?.value || 1,
      followupDate: followupDate || null,
      assignedUser1: assignedUser1?.value || undefined,
      assignedUser2: assignedUser2?.value || undefined,
      assignedUser3: assignedUser3?.value || undefined,
      isPrivate,
      other,
    };

    if (isEditMode) {
      mutateUpdateLead({
        url: "/admin/lead/update/" + id,
        data: leadData,
      });
    } else {
      mutateCreateLead(leadData);
    }
  };

  const handleAddFollowup = async () => {
    if (!followupNote) {
      UseToast("Please enter followup note", "error");
      return;
    }

    // Check if status has changed and update lead if so
    if (followupStatus?.value && followupStatus?.value !== status?.value) {
      mutateUpdateLead({
        url: "/admin/lead/update/" + id,
        data: {
          status: followupStatus.value,
        },
      });
      setStatus(followupStatus); // Update local state
    }

    if (editingFollowupId) {
      // Update existing followup
      mutateUpdateFollowup({
        url: `/admin/leadfollowups/update/${editingFollowupId}`,
        data: {
          note: followupNote,
          date: followupNextDate || null,
          status: followupStatus?.value || null,
        },
      });
    } else {
      // Create new followup
      mutateAddFollowup({
        leadId: Number(id),
        note: followupNote,
        date: followupNextDate || null,
        status: followupStatus?.value || null,
      });
    }
  };

  const handleEditFollowup = (followup: any) => {
    setFollowupNote(followup.note || "");
    setFollowupNextDate(followup.date ? moment(followup.date).format("YYYY-MM-DD") : "");
    setFollowupStatus(followup.status ? { value: followup.status, label: followup.status } : null);
    setEditingFollowupId(followup.id);
    onOpen();
  };

  const handleDeleteFollowup = (followupId: any) => {
    if (window.confirm("Are you sure you want to delete this followup?")) {
      mutateDeleteFollowup(followupId);
    }
  };

  const handleOpenAddModal = () => {
    setFollowupNote("");
    setFollowupNextDate("");
    setFollowupStatus(status); // Initialize with current lead status
    setEditingFollowupId(null);
    onOpen();
  };

  const getStatusColor = (status: string) => {
    switch (status?.toLowerCase()) {
      case "under follow-up":
        return "primary";
      case "on hold":
        return "secondary";
      case "negotiation":
        return "warning";
      case "dropped":
        return "danger";
      case "signed":
        return "success";
      default:
        return "default";
    }
  };

  return (
    <>
      {(isCreating || isUpdating) && <Spinner />}

      <div className="px-4 py-2 [&_input]:border-none [&_input]:px-0 [&_textarea]:border-none [&_textarea]:px-0 font-inter">
        <div className="flex justify-between items-center mb-">
          <div className="flex gap-10 items-center">
            <h1 className="text-2xl font-bold font-inter">{isEditMode ? "Edit Lead" : "New Lead"}</h1>
            <div className="flex gap-2 items-center">
              <label className="text- font-semibold text-gray-600 mb-1">Status</label>
              <Select
                options={statusOptions}
                value={status}
                onChange={setStatus}
                placeholder="Select Status"
                className="text-sm z-20"
                isClearable
              />
            </div>
          </div>
          <div className="flex gap-2">
            <Button color="default" variant="flat" onPress={() => navigate("/af/leads")}>
              Back to Leads
            </Button>
            <Button color="primary" isLoading={isCreating || isUpdating} onPress={handleSubmit}>
              {isEditMode ? "Update Lead" : "Create Lead"}
            </Button>
          </div>
        </div>

        {/* Top Section - Quick Info */}
        <div className="grid grid-cols-4 gap-4 mb-4 rounded-lg">
          {/*<div className="flex flex-col">
            <label className="text-xs font-semibold text-gray-600 mb-1">Priority</label>
            <Select
              options={priorityOptions}
              value={priority}
              onChange={setPriority}
              placeholder="Select Priority"
              className="text-sm z-20"
              isClearable
            />
          </div>
          <div className="flex flex-col">
            <Input
              type="date"
              label="Next Followup"
              labelPlacement="outside-top"
              variant="bordered"
              value={followupDate == "Invalid Date" ? "" : followupDate}
              onValueChange={setFollowupDate}
              size="sm"
            />
          </div>*/}
          {/*<div className="flex flex-col">
            <label className="text-xs font-semibold text-gray-600 mb-1">Assigned User</label>
            <Select
              options={userList}
              value={assignedUser1}
              onChange={setAssignedUser1}
              placeholder="Select User"
              className="text-sm z-20"
              isClearable
            />
          </div>*/}
        </div>

        {/* Main Section - Form and Followups */}
        <div className="grid grid-cols-5 gap-4">
          {/* Left Section - Lead Form (2/3 width) */}
          <Card className="col-span-2">
            <CardBody className="p-4">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
              >
                <div className="space-y-4">
                  {/* Contact Person Information */}
                  <div className="border-b pb-4">
                    <div className="grid grid-cols-2 gap-3">
                      <Input
                        type="text"
                        label="Company"
                        labelPlacement="outside-top"
                        value={company}
                        isRequired
                        onValueChange={setCompany}
                        placeholder="Company name"
                        size="sm"
                      />
                      <Input
                        type="text"
                        label="Contact Person Name"
                        labelPlacement="outside-top"
                        value={contactPersonName}
                        onValueChange={setContactPersonName}
                        placeholder="Contact person name"
                        size="sm"
                        isRequired
                      />
                      <Input
                        type="tel"
                        label="Contact Person Phone"
                        labelPlacement="outside-top"
                        value={contactPersonPhone}
                        onValueChange={setContactPersonPhone}
                        placeholder="Contact phone"
                        size="sm"
                        isRequired
                      />
                      <Input
                        type="email"
                        label="Contact Person Email"
                        labelPlacement="outside-top"
                        value={contactPersonEmail}
                        onValueChange={setContactPersonEmail}
                        placeholder="Contact email"
                        size="sm"
                        isRequired
                      />

                      <Input
                        type="text"
                        label="Website"
                        labelPlacement="outside-top"
                        value={website}
                        onValueChange={setWebsite}
                        size="sm"
                      />
                      <Input
                        type="text"
                        label="City"
                        labelPlacement="outside-top"
                        value={city}
                        onValueChange={setCity}
                        placeholder="City"
                        size="sm"
                      />
                    </div>
                    <div className="mt-3">
                      <Textarea
                        label="Address"
                        labelPlacement="outside-top"
                        value={address}
                        onValueChange={setAddress}
                        placeholder="Full address"
                        minRows={2}
                        size="sm"
                      />
                    </div>
                  </div>

                  {/* Customer Information */}
                  <div className="border-b pb-4 hidden">
                    <h2 className="text-lg font-semibold mb-3 text-gray-700">Customer Information</h2>
                    <div className="grid grid-cols-2 gap-3">
                      <Input
                        type="text"
                        label="Customer Name"
                        labelPlacement="outside-top"
                        value={name}
                        onValueChange={setName}
                        placeholder="Customer name"
                        size="sm"
                      />
                      <Input
                        type="email"
                        label="Customer Email"
                        labelPlacement="outside-top"
                        value={email}
                        onValueChange={setEmail}
                        placeholder="email@example.com"
                        size="sm"
                      />
                      <Input
                        type="tel"
                        label="Customer Phone"
                        labelPlacement="outside-top"
                        value={phone}
                        onValueChange={setPhone}
                        placeholder="Phone number"
                        size="sm"
                      />

                      {/*<Input type="text" label="GST Number" labelPlacement="outside-top" value={gst} onValueChange={setGst} size="sm" />*/}
                    </div>
                  </div>

                  {/* Lead Details */}
                  <div className="border-b pb-4">
                    <h2 className="text-lg font-semibold mb-3 text-gray-700">Extra Details</h2>
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Source</label>
                        <Select
                          options={sourceOptions}
                          value={source}
                          onChange={setSource}
                          placeholder="Select Source"
                          className="text-sm z-20"
                          isClearable
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Products</label>
                        <Select
                          options={productList}
                          value={products}
                          onChange={setProducts}
                          placeholder="Select Products"
                          className="text-sm z-20"
                          closeMenuOnSelect={false}
                          isMulti
                          isClearable
                        />
                      </div>
                      {/*<div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Additional User 2</label>
                        <Select
                          options={userList}
                          value={assignedUser2}
                          onChange={setAssignedUser2}
                          placeholder="Select User"
                          className="text-sm"
                          isClearable
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Additional User 3</label>
                        <Select
                          options={userList}
                          value={assignedUser3}
                          onChange={setAssignedUser3}
                          placeholder="Select User"
                          className="text-sm"
                          isClearable
                        />
                      </div>*/}
                      {/*<div className="flex items-center">
                        <Checkbox isSelected={isPrivate} onValueChange={setIsPrivate} size="sm">
                          Private Lead
                        </Checkbox>
                      </div>*/}
                    </div>
                    {/* Title & Description */}
                    <div className="border-b pb-4 mt-4">
                      <div className="space-y-3">
                        {/*<Input
                        type="text"
                        label="Title"
                        labelPlacement="outside-top"
                        value={title}
                        onValueChange={setTitle}
                        placeholder="Enter lead title"
                        isRequired
                        size="sm"
                      />*/}
                        <Textarea
                          label="Description"
                          labelPlacement="outside"
                          value={desc}
                          onValueChange={setDesc}
                          placeholder="Enter lead description"
                          minRows={3}
                          size="sm"
                        />
                      </div>
                    </div>
                    <div className="mt-3">
                      <Textarea
                        label="Other Notes"
                        labelPlacement="outside"
                        value={other}
                        onValueChange={setOther}
                        placeholder="Any other information"
                        minRows={2}
                        size="sm"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </CardBody>
          </Card>

          {/* Right Section - Followups (1/3 width) */}
          <Card className="col-span-3 border-3 border-primary">
            <CardBody className="p-4">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-gray-700">Followups</h2>
                {isEditMode && (
                  <Button size="md" color="success" onClick={handleOpenAddModal}>
                    + Add
                  </Button>
                )}
              </div>

              {!isEditMode ? (
                <div className="text-center text-gray-500 text-sm py-8">Save the lead first to add followups</div>
              ) : isLoadingFollowups ? (
                <div className="text-center py-8">
                  <Spinner />
                </div>
              ) : followupList.length === 0 ? (
                <div className="text-center text-gray-500 text-sm py-8">No followups yet</div>
              ) : (
                <div className="space-y-3 max-h-[600px] overflow-y-auto">
                  {followupList.map((followup: any, index: number) => (
                    <div key={index} className="border border-gray-200 rounded-md p-3 bg-gray-50">
                      <div className="flex justify-between items-start mb-2">
                        <span className="text-xs text-gray-500">{followup.createdAt}</span>
                        {followup.status && (
                          <Chip color={getStatusColor(followup.status)} size="sm" variant="flat">
                            {followup.status}
                          </Chip>
                        )}
                        <div className="flex gap-2">
                          <button onClick={() => handleEditFollowup(followup)} className="text-xs text-blue-600 hover:underline">
                            Edit
                          </button>
                          <button onClick={() => handleDeleteFollowup(followup.id)} className="text-xs text-red-600 hover:underline">
                            Delete
                          </button>
                        </div>
                      </div>
                      <p className="text-sm text-black-900 mb-2 font-semibold">{followup.note}</p>
                      {followup.date && followup.date != "Invalid Date" && (
                        <div className="text-xs text-blue-600 font-medium mb-2">
                          Next Followup: {moment(followup.date, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY")}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </div>

      {/* Add Followup Modal */}

      {/* Add Followup Modal */}
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} size="2xl" placement="center" isDismissable={false}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader>{editingFollowupId ? "Edit Followup" : "Add Followup"}</ModalHeader>
              <ModalBody>
                <div className="space-y-4 [&_input]:border-none [&_input]:px-0 [&_textarea]:border-none [&_textarea]:px-0 ">
                  <Textarea
                    label="Followup Note"
                    labelPlacement="outside"
                    variant="bordered"
                    value={followupNote}
                    onValueChange={setFollowupNote}
                    placeholder="Enter followup details"
                    minRows={4}
                    isRequired
                  />
                  <div className="grid grid-cols-2 gap-3">
                    <Input
                      type="date"
                      label="Next Followup Date"
                      labelPlacement="outside-top"
                      variant="bordered"
                      value={followupNextDate}
                      onValueChange={setFollowupNextDate}
                    />
                    <div>
                      <label className="text-sm font-medium text-gray-700 mb-1 block">Lead Status</label>
                      <Select
                        options={statusOptions}
                        value={followupStatus}
                        onChange={setFollowupStatus}
                        placeholder="Select Status"
                        className="text-sm"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                      />
                    </div>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                <Button color="primary" onPress={handleAddFollowup} isLoading={isAddingFollowup || isUpdatingFollowup}>
                  {editingFollowupId ? "Update Followup" : "Add Followup"}
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default NewLead;
